(ns manatee.admin.task-config.app-db
  "App. DB support for task configurations."
  (:require [utility-belt.uuid :refer [str->uuid]]))

(def root :task-configs)
(def root-path [root])
(def task-config-id-path
  [:kee-frame/route :route-params :task-config-id])

(defn get-task-config-id
  [db]
  (get-in db task-config-id-path))

(defn get-selected-task
  [db]
  (let [task-configs (-> (get-in db root-path)
                         vals)]
    (->> (filter (fn [v] (:selected? v)) task-configs)
         first)))

(defn clear-selected-task
  [db]
  (let [task-config-ids (keys (get db :task-configs))]
    (loop [n 0
           acc db]
      (if (= n (count task-config-ids))
        acc
        (let [task-id (nth task-config-ids n)
              task-path (conj root-path task-id)
              task-config (-> (get-in db task-path)
                              (assoc :selected? false))]
          (recur (+ n 1) (assoc-in acc [root task-id] task-config)))))))

(defn set-selected-task
  [db selected-task-id]
  (-> (clear-selected-task db)
      (assoc-in [root selected-task-id :selected?] true)))

(defn get-task-config
  "Get a task configuration by identifier."
  [db id]
  (get-in db
          (conj root-path
                (str id))))

(defn get-task-config-map
  "Return the full map from task-config-id to the corresponding config."
  [db]
  (get-in db root-path))

(defn get-task-configs
  "Return a sequence containing the task configurations
   (omitting those for which `:archive-task?` is `true` if `active-only?` is `true`))."
  [db active-only?]
  (let [all-task-configs (-> (get-in db root-path)
                             vals)]
    (if active-only?
      (remove #(get-in % [:data :modifiers :archive-task?])
              all-task-configs)
      all-task-configs)))

(defn get-task-config-names
  [db]
  (->> (get-in db root-path)
       (vals)
       (map :task-name)))

(defn get-task-ids-by-name
  [db]
  (as-> (get-in db root-path) $
    (vals $)
    (group-by :task-name $)
    (update-vals $ #(mapv (comp str->uuid :id) %))))

(defn set-task-configs
  "Set the task configurations with `task-configs` (a map from task config.
   identifier (as a string) to the corresponding config.)."
  [db task-configs]
  (assoc-in db root-path task-configs))
